export const PROJECT_DOCUMENT_ACCEPT =
  '.txt,.md,.markdown,.csv,.json,.log,.html,.htm,.xml,.yaml,.yml,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.rtf,.odt,.ods,.odp,.png,.jpg,.jpeg,.webp,.svg,.ai,.sqlite,.sqlite3,.db';

/** Whether Chat can read this file (SVG becomes an image, an Illustrator file is read as PDF). */
export function isSupportedAttachment(filename: string): boolean {
  const ext = filename.split('.').pop()?.toLowerCase() ?? '';
  return PROJECT_DOCUMENT_ACCEPT.split(',').includes(`.${ext}`);
}

export function isSqliteFilename(filename: string): boolean {
  const ext = filename.split('.').pop()?.toLowerCase();
  return ext === 'sqlite' || ext === 'sqlite3' || ext === 'db';
}

/** Pictures that can be shown as a thumbnail (an Illustrator file is not one). */
export function isImageFilename(filename: string): boolean {
  const ext = filename.split('.').pop()?.toLowerCase() ?? '';
  return ext === 'png' || ext === 'jpg' || ext === 'jpeg' || ext === 'webp' || ext === 'svg';
}
